import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const currentYear = new Date().getFullYear();
const TITLE = `حاسبة ضريبة القيمة المضافة - حساب الضريبة بدقة`;
const DESCRIPTION = `احسب ضريبة القيمة المضافة (VAT) ${currentYear} بدقة باستخدام حاسبة الضريبة المجانية. أداة سهلة لحساب ضريبة المبيعات والمشتريات مع إضافة أو استخراج الضريبة من أي مبلغ. احسب الضريبة الشهرية للأعمال التجارية بسهولة مع شرح مفصل وأمثلة عملية.`;
const KEYWORDS = `حاسبة ضريبة القيمة المضافة ${currentYear}, حساب الضريبة, VAT calculator, ضريبة المبيعات, ضريبة المشتريات, حساب ضريبة 15%, احتساب الضريبة, إضافة ضريبة القيمة المضافة, استخراج الضريبة, ضريبة الأعمال التجارية, حاسبة VAT, قيمة الضريبة, المبلغ شامل الضريبة, الضريبة على الخدمات`;
const OG_URL = "https://do-calculate.com/calculator/ar/vat/";
function VATCalculator() {
  const [saleValue, setSaleValue] = useState("");
  const [vatRate, setVatRate] = useState("15");
  const [isSaleInclusiveOfVAT, setIsSaleInclusiveOfVAT] = useState("false");
  const [saleValueError, setSaleValueError] = useState("");
  const [vatRateError, setVatRateError] = useState("");
  const [vatResult, setVatResult] = useState("");
  const [totalValue, setTotalValue] = useState("");
  const [priceBeforeVat, setPriceBeforeVat] = useState("");
  const handleVatRateChange = (event) => {
    const inputVat = event.target.value;
    if (inputVat !== "") {
      const parsedVat = parseFloat(inputVat);
      if (!isNaN(parsedVat) && parsedVat >= 0 && parsedVat <= 100) {
        setVatRate(inputVat);
        setVatRateError("");
      } else {
        setVatRate(inputVat);
        if (isNaN(parsedVat)) {
          setVatRateError("تأكد من إدخال رقم صحيح");
        } else if (parsedVat < 0) {
          setVatRateError("الضريبة لا يمكن أن تكون سالبة");
        } else if (parsedVat > 100) {
          setVatRateError("الضريبة يجب أن تكون بين 0 - 100%");
        }
      }
    } else {
      setVatRate("");
      setVatRateError("");
    }
  };
  const handleSaleChange = (event) => {
    const inputSale = event.target.value;
    if (inputSale !== "") {
      const parsedSale = parseFloat(inputSale);
      if (!isNaN(parsedSale) && parsedSale >= 0) {
        setSaleValue(inputSale);
        setSaleValueError("");
      } else {
        setSaleValue(inputSale);
        if (isNaN(parsedSale)) {
          setSaleValueError("تأكد من إدخال رقم صحيح");
        } else if (parsedSale < 0) {
          setSaleValueError("القيمة لا يمكن أن تكون سالبة");
        }
      }
    } else {
      setSaleValue("");
      setSaleValueError("");
    }
  };
  const handleReset = () => {
    setSaleValue("");
    setVatRate("15");
    setIsSaleInclusiveOfVAT("false");
    setSaleValueError("");
    setVatRateError("");
    setVatResult("");
    setTotalValue("");
    setPriceBeforeVat("");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const sale = parseFloat(saleValue);
    const rate = parseFloat(vatRate);
    if (isNaN(sale) || isNaN(rate)) {
      return;
    }
    if (isSaleInclusiveOfVAT === "false") {
      // إضافة الضريبة
      const vatAmount = sale * (rate / 100);
      const total = sale + vatAmount;
      setVatResult(vatAmount.toFixed(2));
      setTotalValue(total.toFixed(2));
      setPriceBeforeVat(sale.toFixed(2));
    } else {
      // استخراج الضريبة
      const priceWithoutVat = sale / (1 + rate / 100);
      const vatAmount = sale - priceWithoutVat;
      setVatResult(vatAmount.toFixed(2));
      setTotalValue(sale.toFixed(2));
      setPriceBeforeVat(priceWithoutVat.toFixed(2));
    }
  };
  // Generate Schema.org structured data
  const generateSchemaData = () => {
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "الصفحة الرئيسية",
          item: "https://do-calculate.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "الحاسبات",
          item: "https://do-calculate.com/ar/all-calculators/",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "حاسبة ضريبة القيمة المضافة",
          item: OG_URL,
        },
      ],
    };
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "ما هي ضريبة القيمة المضافة؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "ضريبة القيمة المضافة (VAT) هي ضريبة غير مباشرة تُفرض على استهلاك السلع والخدمات في كل مرحلة من مراحل الإنتاج والتوزيع. تطبق في أكثر من 160 دولة حول العالم.",
          },
        },
        {
          "@type": "Question",
          name: "كيف أحسب ضريبة القيمة المضافة؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "لحساب ضريبة القيمة المضافة: إذا كان المبلغ قبل الضريبة، اضرب في نسبة الضريبة (مثلاً 15%)، ثم اجمع الناتج مع المبلغ الأصلي. إذا كان المبلغ شامل الضريبة، اقسم على (1 + نسبة الضريبة).",
          },
        },
        {
          "@type": "Question",
          name: "كم نسبة ضريبة القيمة المضافة في السعودية؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "نسبة ضريبة القيمة المضافة في المملكة العربية السعودية هي 15% اعتباراً من 1 يوليو 2020.",
          },
        },
        {
          "@type": "Question",
          name: "ما الفرق بين إضافة الضريبة واستخراجها؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "إضافة الضريبة: عندما يكون السعر قبل الضريبة وتريد معرفة السعر النهائي. استخراج الضريبة: عندما يكون السعر شامل الضريبة وتريد معرفة قيمة الضريبة والسعر قبلها.",
          },
        },
        {
          "@type": "Question",
          name: "هل جميع السلع والخدمات تخضع لضريبة القيمة المضافة؟",
          acceptedAnswer: {
            "@type": "Answer",
            text: "لا، هناك بعض السلع والخدمات المعفاة أو الخاضعة لنسبة صفر، مثل: الصادرات الدولية، الخدمات الصحية والتعليمية الحكومية، بعض الخدمات المالية، وبعض أنواع العقارات.",
          },
        },
      ],
    };
    const calculatorSchema = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      name: "حاسبة ضريبة القيمة المضافة",
      description: DESCRIPTION,
      url: OG_URL,
      applicationCategory: "FinanceApplication",
      operatingSystem: "Any",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
      },
    };
    return [breadcrumbSchema, faqSchema, calculatorSchema];
  };
  return (
    <div className="rtl" style={{ direction: "rtl" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
        SCHEMA={generateSchemaData()}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "12px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            {/* Introduction */}
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة ضريبة القيمة المضافة</strong> هي أداة مجانية
                وسهلة الاستخدام لـ<strong>حساب الضريبة</strong> بدقة. يمكنك{" "}
                <strong>إضافة الضريبة</strong> إلى أي مبلغ أو{" "}
                <strong>استخراجها</strong> من المبلغ الإجمالي. مناسبة للأفراد
                والشركات لحساب <strong>ضريبة المبيعات</strong> و
                <strong>ضريبة المشتريات</strong> في أي دولة بنسب ضريبة مختلفة.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds/>
              {/* Calculator Section */}
            <div className="row">
             <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>
                    احسب ضريبة القيمة المضافة
                  </h2>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="form-group mb-3">
                    <label  htmlFor="saleValue">
                      <strong>قيمة البيع / الشراء:</strong>
                    </label>
                    <div className="d-flex align-items-center">
                      <input
                        id="saleValue"
                        type="number"
                        className="form-control"
                        value={saleValue}
                        onChange={handleSaleChange}
                        placeholder="مثال: 1000"
                        step="0.01"
                        min="0"
                        required
                        style={{ maxWidth: "200px" }}
                      />
                    </div>
                    {saleValueError && (
                      <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                        {saleValueError}
                      </div>
                    )}
                  </div>
                  <div className="form-group mb-3">
                    <label  htmlFor="vatRate">
                      <strong>نسبة الضريبة (%):</strong>
                    </label>
                    <div className="d-flex align-items-center">
                      <input
                        id="vatRate"
                        type="number"
                        className="form-control"
                        value={vatRate}
                        onChange={handleVatRateChange}
                        placeholder="مثال: 15"
                        step="0.01"
                        min="0"
                        max="100"
                        required
                        style={{ maxWidth: "200px" }}
                      />
                      <span
                        style={{
                          marginRight: "10px",
                          padding: "8px 15px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "#f9f9f9",
                          fontSize: "16px",
                        }}
                      >
                        %
                      </span>
                    </div>
                    {vatRateError && (
                      <div className="text-danger mt-1" style={{ fontSize: "14px" }}>
                        {vatRateError}
                      </div>
                    )}
                  </div>
                  <div className="form-group mb-4">
                    <label >
                      <strong>هل المبلغ يشمل ضريبة القيمة المضافة؟</strong>
                    </label>
                    <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                      <label style={{ cursor: "pointer", fontSize: "16px" }}>
                        <input
                          type="radio"
                          name="includeVat"
                          value="false"
                          checked={isSaleInclusiveOfVAT === "false"}
                          onChange={(e) => setIsSaleInclusiveOfVAT(e.target.value)}
                          style={{ marginLeft: "8px" }}
                        />
                        لا (إضافة الضريبة)
                      </label>
                      <label style={{ cursor: "pointer", fontSize: "16px" }}>
                        <input
                          type="radio"
                          name="includeVat"
                          value="true"
                          checked={isSaleInclusiveOfVAT === "true"}
                          onChange={(e) => setIsSaleInclusiveOfVAT(e.target.value)}
                          style={{ marginLeft: "8px" }}
                        />
                        نعم (استخراج الضريبة)
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="d-flex gap-2">
                    <button
                      type="submit"
                      className="btn bg-success text-white"
                      style={{ fontSize: "16px", padding: "10px 30px" }}
                    >
                      احسب
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleReset}
                       style={{ fontSize: "16px", padding: "10px 30px", marginRight: "10px" }}
                    >
                      امسح

                    </button>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-4">
                {vatResult && totalValue && (
                  <div className="calculatorStyle">
                    <div className="p-3 mb-3 bg-success text-white text-center rounded">
                      <h3 style={{ fontSize: "18px", margin: 0 }}>النتيجة</h3>
                    </div>
                    <div className="alert alert-success" style={{ fontSize: "16px" }}>
                      <table className="bmi-table" style={{ width: "100%" }}>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#e7f3fe",
                                padding: "12px",
                              }}
                            >
                              <strong>المبلغ قبل الضريبة:</strong>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#e7f3fe",
                                padding: "12px",
                              }}
                            >
                              <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                                {priceBeforeVat}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#fff3cd",
                                padding: "12px",
                              }}
                            >
                              <strong>مبلغ الضريبة ({vatRate}%):</strong>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#fff3cd",
                                padding: "12px",
                              }}
                            >
                              <strong style={{ fontSize: "18px", color: "#856404" }}>
                                {vatResult}
                              </strong>
                            </td>
                          </tr>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#d1ecf1",
                                padding: "12px",
                              }}
                            >
                              <strong>المبلغ الإجمالي (شامل الضريبة):</strong>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                backgroundColor: "#d1ecf1",
                                padding: "12px",
                              }}
                            >
                              <strong style={{ fontSize: "20px", color: "#0c5460" }}>
                                {totalValue}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div
              className="alert alert-info"
              style={{ fontSize: "15px", lineHeight: "1.8" }}
            >
              <strong>💡 نصيحة:</strong> <strong>حاسبة الضريبة</strong> هذه تدعم
              جميع نسب الضريبة المستخدمة في الدول العربية والعالمية. يمكنك حساب
              الضريبة بنسبة 5%، 10%، 15%، أو أي نسبة أخرى حسب دولتك.
            </div>
            <hr />
            {/* Related Links */}
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Educational Content Section */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>ما هي ضريبة القيمة المضافة؟ دليل شامل</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>ضريبة القيمة المضافة</strong> (Value Added Tax - VAT)
                  هي <strong>ضريبة غير مباشرة</strong> تُفرض على استهلاك السلع
                  والخدمات في كل مرحلة من مراحل الإنتاج والتوزيع. تُعتبر من
                  أهم مصادر الإيرادات الحكومية في أكثر من <strong>160 دولة</strong>{" "}
                  حول العالم.
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيف تعمل ضريبة القيمة المضافة؟
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  الضريبة تُفرض في كل مرحلة من <strong>سلسلة التوريد</strong>:
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>المصنع:</strong> يشتري المواد الخام ويدفع ضريبة عليها،
                    ثم ينتج السلعة ويبيعها مع إضافة الضريبة.
                  </li>
                  <li>
                    <strong>تاجر الجملة:</strong> يشتري من المصنع ويدفع الضريبة،
                    ثم يبيع لتاجر التجزئة مع إضافة الضريبة.
                  </li>
                  <li>
                    <strong>تاجر التجزئة:</strong> يشتري من تاجر الجملة ويدفع
                    الضريبة، ثم يبيع للمستهلك النهائي مع إضافة الضريبة.
                  </li>
                  <li>
                    <strong>المستهلك النهائي:</strong> يدفع السعر الكامل شاملاً
                    الضريبة.
                  </li>
                </ol>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 مثال عملي:</strong>
                  <br />
                  مصنع ينتج قميصاً بتكلفة 50 ، يبيعه لتاجر بـ70  + ضريبة
                  15% = 80.50 .
                  <br />
                  التاجر يبيعه للمستهلك بـ100  + ضريبة 15% = 115 .
                  <br />
                  <strong>الضريبة النهائية:</strong> 15  يدفعها المستهلك.
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  خصائص ضريبة القيمة المضافة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>ضريبة غير مباشرة:</strong> يدفعها المستهلك لكن
                    تُجمع عبر البائعين
                  </li>
                  <li>
                    <strong>تدفع على القيمة المضافة:</strong> فقط على الفرق بين
                    سعر الشراء والبيع
                  </li>
                  <li>
                    <strong>قابلة للخصم:</strong> الشركات تسترد الضريبة التي
                    دفعتها على المشتريات
                  </li>
                  <li>
                    <strong>شفافة:</strong> تظهر بوضوح في الفواتير
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>كيف تحسب ضريبة القيمة المضافة؟ الصيغ والأمثلة</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  هناك طريقتان لـ<strong>حساب ضريبة القيمة المضافة</strong>:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  1. إضافة الضريبة إلى السعر
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  تُستخدم عندما يكون <strong>السعر قبل الضريبة</strong> وتريد
                  معرفة السعر النهائي:
                </p>
                <div
                  className="alert alert-success"
                  style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                >
                  <strong>الصيغة:</strong>
                  <br />
                  <code style={{ fontSize: "16px" }}>
                    مبلغ الضريبة = السعر × (نسبة الضريبة ÷ 100)
                    <br />
                    السعر الإجمالي = السعر + مبلغ الضريبة
                    <br />
                    أو: السعر الإجمالي = السعر × (1 + نسبة الضريبة ÷ 100)
                  </code>
                </div>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>مثال:</strong>
                  <br />
                  سلعة سعرها 1000 ، الضريبة 15%
                  <br />
                  مبلغ الضريبة = 1000 × (15 ÷ 100) = <strong>150 </strong>
                  <br />
                  السعر النهائي = 1000 + 150 = <strong>1150 </strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  2. استخراج الضريبة من السعر الإجمالي
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  تُستخدم عندما يكون <strong>السعر شامل الضريبة</strong> وتريد
                  معرفة قيمة الضريبة والسعر قبلها:
                </p>
                <div
                  className="alert alert-warning"
                  style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
                >
                  <strong>الصيغة:</strong>
                  <br />
                  <code style={{ fontSize: "16px" }}>
                    السعر قبل الضريبة = السعر الإجمالي ÷ (1 + نسبة الضريبة ÷ 100)
                    <br />
                    مبلغ الضريبة = السعر الإجمالي - السعر قبل الضريبة
                  </code>
                </div>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>مثال:</strong>
                  <br />
                  سلعة سعرها 1150  شامل ضريبة 15%
                  <br />
                  السعر قبل الضريبة = 1150 ÷ (1 + 15 ÷ 100) = 1150 ÷ 1.15 ={" "}
                  <strong>1000 </strong>
                  <br />
                  مبلغ الضريبة = 1150 - 1000 = <strong>150 </strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  صيغة مختصرة لحساب الضريبة سريعاً:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>للضريبة 5%:</strong> اضرب في 0.05 (إضافة) أو اقسم على
                    21 (استخراج)
                  </li>
                  <li>
                    <strong>للضريبة 10%:</strong> اضرب في 0.10 (إضافة) أو اقسم
                    على 11 (استخراج)
                  </li>
                  <li>
                    <strong>للضريبة 15%:</strong> اضرب في 0.15 (إضافة) أو اقسم
                    على 7.67 (استخراج)
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>
                  ضريبة القيمة المضافة في الدول العربية - النسب والتطبيق
                </strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  تختلف <strong>نسبة ضريبة القيمة المضافة</strong> من دولة لأخرى
                  في المنطقة العربية:
                </p>
                <table className="bmi-table" style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <th className="bmi-header" style={{ textAlign: "center" }}>
                        الدولة
                      </th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>
                        النسبة
                      </th>
                      <th className="bmi-header" style={{ textAlign: "center" }}>
                        تاريخ التطبيق
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>السعودية</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          15%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        يوليو 2020
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>الإمارات</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          5%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        يناير 2018
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>البحرين</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          10%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        يناير 2022
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>عُمان</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          5%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        أبريل 2021
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>مصر</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          14%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        سبتمبر 2016
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>المغرب</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          20%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        (ضريبة متدرجة)
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>الأردن</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          16%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        يناير 2018
                      </td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        <strong>لبنان</strong>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          backgroundColor: "#e7f3fe",
                        }}
                      >
                        <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>
                          11%
                        </strong>
                      </td>
                      <td style={{ textAlign: "center", padding: "12px" }}>
                        فبراير 2002
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div
                  className="alert alert-warning mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>⚠️ ملاحظة:</strong> هذه النسب قد تتغير. تأكد من النسبة
                  الحالية في دولتك من الموقع الرسمي للهيئة الضريبية.
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  السلع والخدمات المعفاة أو ذات النسبة الصفرية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>الصادرات الدولية:</strong> نسبة صفر (يمكن استرداد
                    الضريبة)
                  </li>
                  <li>
                    <strong>الخدمات الصحية:</strong> معفاة في معظم الدول
                  </li>
                  <li>
                    <strong>التعليم:</strong> معفى في معظم الدول (حكومي وخاص)
                  </li>
                  <li>
                    <strong>العقارات السكنية:</strong> معفاة أو نسبة صفر في بعض
                    الحالات
                  </li>
                  <li>
                    <strong>الخدمات المالية:</strong> بعضها معفى
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>من يجب عليه التسجيل في ضريبة القيمة المضافة؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>التسجيل الإلزامي</strong> في نظام ضريبة القيمة المضافة
                  يعتمد على حجم الإيرادات السنوية:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  في السعودية:
                </h3>
                <div
                  className="alert alert-success"
                  style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                >
                  <strong>1. التسجيل الإلزامي:</strong>
                  <br />
                  إذا كانت إيراداتك السنوية تتجاوز <strong>375,000 </strong>، يجب
                  التسجيل خلال <strong>30 يوماً</strong>.
                  <br/>                  <strong>2. التسجيل الاختياري:</strong>
                  <br />
                  إذا كانت إيراداتك بين <strong>187,500 - 375,000 </strong>،
                  يمكنك التسجيل اختيارياً.
                  <br/>                  <strong>3. غير ملزم:</strong>
                  <br />
                  إذا كانت إيراداتك أقل من <strong>187,500 </strong>، لست ملزماً
                  بالتسجيل.
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  في الإمارات:
                </h3>
                <div
                  className="alert alert-info"
                  style={{ lineHeight: "1.8", backgroundColor: "#d1ecf1" }}
                >
                  <strong>التسجيل الإلزامي:</strong> إيرادات تتجاوز{" "}
                  <strong>375,000 درهم</strong> سنوياً
                  <br />
                  <strong>التسجيل الاختياري:</strong> إيرادات بين{" "}
                  <strong>187,500 - 375,000 درهم</strong>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  متطلبات التسجيل:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>السجل التجاري:</strong> يجب أن يكون لديك سجل تجاري ساري
                  </li>
                  <li>
                    <strong>الحساب البنكي:</strong> حساب تجاري باسم المنشأة
                  </li>
                  <li>
                    <strong>بيانات المالك:</strong> هوية المالك أو المديرين
                  </li>
                  <li>
                    <strong>عنوان المنشأة:</strong> عنوان تجاري ثابت
                  </li>
                  <li>
                    <strong>البيانات المالية:</strong> إثبات الإيرادات والمبيعات
                  </li>
                </ol>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  فوائد التسجيل في ضريبة القيمة المضافة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>استرداد الضريبة:</strong> يمكنك استرداد الضريبة التي
                    دفعتها على مشترياتك
                  </li>
                  <li>
                    <strong>الامتثال القانوني:</strong> تجنب الغرامات والعقوبات
                  </li>
                  <li>
                    <strong>مصداقية أكبر:</strong> يعطي ثقة أكبر للعملاء والموردين
                  </li>
                  <li>
                    <strong>التعامل مع الشركات الكبرى:</strong> كثير من الشركات لا
                    تتعامل إلا مع مسجلين في الضريبة
                  </li>
                </ul>
                <div
                  className="alert alert-warning mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>⚠️ تحذير:</strong> عدم التسجيل عند تجاوز الحد الإلزامي
                  يعرضك لغرامات قد تصل إلى <strong>10,000 </strong> في
                  السعودية.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>كيفية إصدار الفواتير الضريبية</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>الفاتورة الضريبية</strong> هي مستند رسمي يجب إصداره عند
                  كل عملية بيع. إليك كل ما تحتاج معرفته:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  أنواع الفواتير:
                </h3>
                <div
                  className="alert alert-success"
                  style={{ lineHeight: "1.8", marginTop: "10px" }}
                >
                  <h4 style={{ fontSize: "16px" }}>
                    <strong>1. الفاتورة الضريبية (للشركات):</strong>
                  </h4>
                  <p>
                    تُستخدم في البيع بين الشركات (B2B)، يجب أن تحتوي على جميع
                    البيانات التفصيلية.
                  </p>
                  <strong>البيانات الإلزامية:</strong>
                  <ul>
                    <li>✓ عبارة "فاتورة ضريبية"</li>
                    <li>✓ اسم وعنوان البائع</li>
                    <li>✓ الرقم الضريبي للبائع (15 رقم)</li>
                    <li>✓ تاريخ إصدار الفاتورة</li>
                    <li>✓ رقم تسلسلي للفاتورة</li>
                    <li>✓ اسم وعنوان المشتري</li>
                    <li>✓ الرقم الضريبي للمشتري (إن وُجد)</li>
                    <li>✓ وصف السلع/الخدمات</li>
                    <li>✓ الكمية والسعر لكل صنف</li>
                    <li>✓ المبلغ قبل الضريبة</li>
                    <li>✓ مبلغ الضريبة (15%)</li>
                    <li>✓ المبلغ الإجمالي شامل الضريبة</li>
                  </ul>
                </div>
                <div
                  className="alert alert-info"
                  style={{ lineHeight: "1.8", marginTop: "10px" }}
                >
                  <h4 style={{ fontSize: "16px" }}>
                    <strong>2. الفاتورة الضريبية المبسطة (للأفراد):</strong>
                  </h4>
                  <p>
                    تُستخدم في البيع للمستهلكين (B2C)، مثل فواتير المحلات
                    والمطاعم.
                  </p>
                  <strong>البيانات الإلزامية (مبسطة):</strong>
                  <ul>
                    <li>✓ عبارة "فاتورة ضريبية مبسطة"</li>
                    <li>✓ اسم البائع</li>
                    <li>✓ الرقم الضريبي (مع رمز QR)</li>
                    <li>✓ تاريخ ووقت الإصدار</li>
                    <li>✓ المبلغ الإجمالي شامل الضريبة</li>
                    <li>✓ مبلغ الضريبة</li>
                  </ul>
                </div>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الفوترة الإلكترونية (ZATCA):
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  اعتباراً من ديسمبر 2021 في السعودية، أصبح{" "}
                  <strong>إصدار الفواتير الإلكترونية</strong> إلزامياً:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>المرحلة الأولى:</strong> إصدار وحفظ إلكتروني مع رمز QR
                  </li>
                  <li>
                    <strong>المرحلة الثانية:</strong> ربط الأنظمة مع هيئة الزكاة
                    والضريبة
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  متطلبات رمز الاستجابة السريعة (QR Code):
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  يجب أن يحتوي على:
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>اسم البائع</li>
                  <li>الرقم الضريبي للبائع</li>
                  <li>تاريخ ووقت الفاتورة</li>
                  <li>المبلغ الإجمالي شامل الضريبة</li>
                  <li>مبلغ الضريبة</li>
                </ol>
                <div
                  className="alert alert-warning mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>⚠️ عقوبة عدم الالتزام:</strong>
                  <ul>
                    <li>عدم إصدار فاتورة: غرامة تصل لـ50,000 </li>
                    <li>فاتورة غير مطابقة: غرامة من 5,000 إلى 50,000 </li>
                    <li>التأخر في الفوترة الإلكترونية: غرامات متدرجة</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>نصائح عملية للتعامل مع ضريبة القيمة المضافة</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  للشركات والتجار:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>احتفظ بجميع الفواتير:</strong> ستحتاجها لاسترداد
                    الضريبة على مشترياتك
                  </li>
                  <li>
                    <strong>افصل حساباتك:</strong> احتفظ بسجلات منفصلة للمبيعات
                    والمشتريات الخاضعة للضريبة
                  </li>
                  <li>
                    <strong>قدم الإقرار في موعده:</strong> التأخير يؤدي لغرامات
                    يومية
                  </li>
                  <li>
                    <strong>استخدم برنامج محاسبي:</strong> يسهل حساب الضريبة
                    وإعداد التقارير
                  </li>
                  <li>
                    <strong>راجع عقودك:</strong> تأكد أن جميع العقود توضح إذا كانت
                    الأسعار شاملة للضريبة أم لا
                  </li>
                  <li>
                    <strong>احسب التدفق النقدي:</strong> تذكر أنك تجمع الضريبة من
                    العملاء لكن تدفعها للحكومة لاحقاً
                  </li>
                </ol>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  للمستهلكين:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>اطلب الفاتورة دائماً:</strong> تأكد أن المحل مسجل
                    ويجمع الضريبة بشكل قانوني
                  </li>
                  <li>
                    <strong>تحقق من الرقم الضريبي:</strong> يمكنك التحقق منه عبر
                    موقع الهيئة
                  </li>
                  <li>
                    <strong>امسح رمز QR:</strong> تأكد من صحة الفاتورة
                  </li>
                  <li>
                    <strong>قارن الأسعار:</strong> بعض المحلات تضيف الضريبة بشكل
                    خاطئ
                  </li>
                  <li>
                    <strong>اعرف حقوقك:</strong> المحل ملزم بإصدار فاتورة ضريبية
                    صحيحة
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  أخطاء شائعة يجب تجنبها:
                </h3>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <ul>
                    <li>
                      ❌ عدم التسجيل عند تجاوز الحد الإلزامي
                    </li>
                    <li>
                      ❌ إصدار فواتير بدون رقم ضريبي
                    </li>
                    <li>
                      ❌ عدم فصل الضريبة في الفاتورة
                    </li>
                    <li>
                      ❌ التأخر في تقديم الإقرار الضريبي
                    </li>
                    <li>
                      ❌ عدم الاحتفاظ بالفواتير لمدة 6 سنوات (إلزامي)
                    </li>
                    <li>
                      ❌ حساب الضريبة بشكل خاطئ
                    </li>
                    <li>
                      ❌ عدم تحديث البيانات عند تغيير النشاط
                    </li>
                  </ul>
                </div>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ نصيحة ذهبية:</strong> استخدم{" "}
                  <strong>حاسبة ضريبة القيمة المضافة</strong> أعلاه بانتظام
                  للتأكد من دقة حساباتك. الدقة في حساب الضريبة توفر عليك مشاكل
                  كبيرة مع الهيئة الضريبية!
                </div>
              </div>
            </div>
          </div>
          <br />
          {/* FAQ Section */}
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            أسئلة متكررة حول ضريبة القيمة المضافة
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي ضريبة القيمة المضافة؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>ضريبة القيمة المضافة</strong> (VAT - Value Added Tax)
                  هي <strong>ضريبة غير مباشرة</strong> تُفرض على استهلاك السلع
                  والخدمات. تُجمع في كل مرحلة من مراحل سلسلة التوريد، من الإنتاج
                  حتى البيع النهائي للمستهلك.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  سميت بـ"<strong>المضافة</strong>" لأنها تُفرض على{" "}
                  <strong>القيمة المضافة</strong> في كل مرحلة - أي الفرق بين سعر
                  الشراء وسعر البيع.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>مثال بسيط:</strong> تاجر يشتري سلعة بـ100  ويبيعها
                  بـ150 . القيمة المضافة هي 50 ، والضريبة تُحسب على هذه
                  الـ50  فقط (وليس على الـ150  كاملة).
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أحسب ضريبة القيمة المضافة؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  لـ<strong>حساب ضريبة القيمة المضافة</strong>، هناك طريقتان:
                </p>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>1. إضافة الضريبة (السعر قبل الضريبة):</strong>
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>مبلغ الضريبة =</strong> السعر × (نسبة الضريبة ÷ 100)
                  <br />
                  <strong>السعر النهائي =</strong> السعر + مبلغ الضريبة
                </p>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>مثال:</strong> سلعة بـ1000 ، الضريبة 15%
                  <br />
                  مبلغ الضريبة = 1000 × 0.15 = 150
                  <br />
                  السعر النهائي = 1000 + 150 = <strong>1150 </strong>
                </div>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>2. استخراج الضريبة (السعر شامل الضريبة):</strong>
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>السعر قبل الضريبة =</strong> السعر الإجمالي ÷ (1 + نسبة
                  الضريبة ÷ 100)
                  <br />
                  <strong>مبلغ الضريبة =</strong> السعر الإجمالي - السعر قبل
                  الضريبة
                </p>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>مثال:</strong> سلعة بـ1150  شامل ضريبة 15%
                  <br />
                  السعر قبل الضريبة = 1150 ÷ 1.15 = 1000
                  <br />
                  مبلغ الضريبة = 1150 - 1000 = <strong>150 </strong>
                </div>
                <p style={{ lineHeight: "1.8", marginTop: "15px" }}>
                  <strong>💡 الحل الأسهل:</strong> استخدم{" "}
                  <strong>حاسبة الضريبة</strong> في أعلى الصفحة للحصول على النتيجة
                  فوراً!
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كم نسبة ضريبة القيمة المضافة في السعودية؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>نسبة ضريبة القيمة المضافة</strong> في المملكة العربية
                  السعودية هي <strong style={{ fontSize: "18px", color: "#1a5f3f" }}>15%</strong>{" "}
                  اعتباراً من <strong>1 يوليو 2020</strong>.
                </p>
                <p style={{ lineHeight: "1.8" }}>
                  <strong>التاريخ الزمني:</strong>
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>قبل 1 يناير 2018:</strong> لا توجد ضريبة قيمة مضافة
                  </li>
                  <li>
                    <strong>1 يناير 2018 - 30 يونيو 2020:</strong> كانت النسبة{" "}
                    <strong>5%</strong>
                  </li>
                  <li>
                    <strong>1 يوليو 2020 - حتى الآن:</strong> أصبحت النسبة{" "}
                    <strong>15%</strong>
                  </li>
                </ul>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>مثال:</strong> سلعة سعرها 1000  قبل الضريبة
                  <br />
                  الضريبة (15%) = 150
                  <br />
                  السعر النهائي = <strong>1150 </strong>
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما الفرق بين إضافة الضريبة واستخراجها؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  الفرق يعتمد على ما إذا كان <strong>السعر المعطى</strong> يشمل
                  الضريبة أم لا:
                </p>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>إضافة الضريبة:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    تُستخدم عندما يكون <strong>السعر قبل الضريبة</strong>
                  </li>
                  <li>تريد معرفة السعر النهائي الذي سيدفعه العميل</li>
                  <li>
                    مثال: بائع يشتري سلعة بـ100  ويريد بيعها بربح 50 ،
                    يحتاج إضافة الضريبة
                  </li>
                  <li>
                    الحساب: 150 + (150 × 15%) = <strong>172.50 </strong>
                  </li>
                </ul>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>استخراج الضريبة:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    تُستخدم عندما يكون <strong>السعر شامل الضريبة</strong>
                  </li>
                  <li>تريد معرفة كم الضريبة ضمن السعر وكم السعر الأصلي</li>
                  <li>
                    مثال: دفعت 115  لسلعة وتريد معرفة كم الضريبة فيها
                  </li>
                  <li>
                    الحساب: السعر الأصلي = 115 ÷ 1.15 = <strong>100 </strong>
                    <br />
                    الضريبة = 115 - 100 = <strong>15 </strong>
                  </li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ ملخص سريع:</strong>
                  <br />
                  <strong>إضافة:</strong> عندك السعر قبل الضريبة → احسب السعر
                  النهائي
                  <br />
                  <strong>استخراج:</strong> عندك السعر النهائي → احسب كم الضريبة
                  فيه
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل جميع السلع والخدمات تخضع لضريبة القيمة المضافة؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>لا</strong>، ليست جميع السلع والخدمات تخضع للضريبة. هناك
                  ثلاثة أنواع:
                </p>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>1. السلع والخدمات الخاضعة للضريبة (15%):</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>معظم السلع الاستهلاكية</li>
                  <li>الإلكترونيات والأجهزة</li>
                  <li>الملابس والأحذية</li>
                  <li>المطاعم والمقاهي</li>
                  <li>الفنادق والإقامة</li>
                  <li>السيارات والوقود</li>
                  <li>الترفيه والسياحة</li>
                </ul>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>2. السلع والخدمات ذات النسبة الصفرية (0%):</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>الصادرات الدولية:</strong> خارج دول مجلس التعاون
                  </li>
                  <li>
                    <strong>الأدوية والمعدات الطبية:</strong> المحددة من وزارة
                    الصحة
                  </li>
                  <li>
                    <strong>المعادن الثمينة:</strong> للاستثمار (ذهب، فضة،
                    بلاتين)
                  </li>
                  <li>
                    <strong>النقل الدولي:</strong> للركاب والبضائع
                  </li>
                </ul>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>3. السلع والخدمات المعفاة (لا تُحسب ضريبة):</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>إيجار العقارات السكنية</strong>
                  </li>
                  <li>
                    <strong>الخدمات المالية:</strong> بعض الخدمات البنكية
                    والتأمينية
                  </li>
                  <li>
                    <strong>بيع العقارات السكنية:</strong> إذا تم شراؤها بنية
                    السكن الشخصي
                  </li>
                </ul>
                <div
                  className="alert alert-warning mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>⚠️ ملاحظة:</strong> بعض السلع قد تكون خاضعة للضريبة في
                  حالات ومعفاة في أخرى. يُنصح بالرجوع لموقع{" "}
                  <strong>هيئة الزكاة والضريبة والجمارك</strong> للتأكد.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  متى يجب علي التسجيل في ضريبة القيمة المضافة؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  يعتمد التسجيل على <strong>حجم إيراداتك السنوية</strong>:
                </p>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <h4 style={{ fontSize: "16px" }}>
                    <strong>التسجيل الإلزامي:</strong>
                  </h4>
                  <p>
                    يجب عليك التسجيل <strong>خلال 30 يوماً</strong> إذا:
                  </p>
                  <ul>
                    <li>
                      إيراداتك السنوية تجاوزت{" "}
                      <strong style={{ fontSize: "18px" }}>375,000 </strong>
                    </li>
                    <li>أو تتوقع أن تتجاوز هذا المبلغ خلال الـ30 يوم القادمة</li>
                  </ul>
                </div>
                <div
                  className="alert alert-warning"
                  style={{ lineHeight: "1.8", backgroundColor: "#fff3cd" }}
                >
                  <h4 style={{ fontSize: "16px" }}>
                    <strong>التسجيل الاختياري:</strong>
                  </h4>
                  <p>يمكنك التسجيل طوعاً إذا:</p>
                  <ul>
                    <li>
                      إيراداتك بين{" "}
                      <strong>187,500 - 375,000  سنوياً</strong>
                    </li>
                    <li>
                      <strong>الفائدة:</strong> يمكنك استرداد الضريبة على مشترياتك
                    </li>
                  </ul>
                </div>
                <div
                  className="alert alert-success"
                  style={{ lineHeight: "1.8", backgroundColor: "#d4edda" }}
                >
                  <h4 style={{ fontSize: "16px" }}>
                    <strong>غير ملزم بالتسجيل:</strong>
                  </h4>
                  <ul>
                    <li>
                      إيراداتك أقل من <strong>187,500  سنوياً</strong>
                    </li>
                    <li>
                      <strong>ملاحظة:</strong> لا يمكنك فرض ضريبة أو استردادها
                    </li>
                  </ul>
                </div>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>كيف تحسب الإيرادات السنوية؟</strong>
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  اجمع قيمة جميع مبيعاتك (قبل الضريبة) خلال آخر 12 شهراً. إذا
                  كنت نشاطاً جديداً، قدّر مبيعاتك المتوقعة للـ12 شهر القادمة.
                </p>
                <div
                  className="alert alert-warning mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>⚠️ عقوبة التأخير:</strong> عدم التسجيل عند تجاوز الحد
                  الإلزامي يعرضك لغرامة تصل إلى <strong>10,000 </strong>.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أسترد ضريبة القيمة المضافة؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  إذا كنت مسجلاً في ضريبة القيمة المضافة، يمكنك{" "}
                  <strong>استرداد الضريبة</strong> التي دفعتها على مشترياتك
                  المتعلقة بنشاطك التجاري.
                </p>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>كيف يعمل الاسترداد؟</strong>
                </h4>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>تجمع الضريبة من عملائك</strong> على مبيعاتك (ضريبة
                    المخرجات)
                  </li>
                  <li>
                    <strong>تدفع ضريبة على مشترياتك</strong> من مورديك (ضريبة
                    المدخلات)
                  </li>
                  <li>
                    <strong>الفرق بينهما</strong> هو ما تدفعه للحكومة أو تسترده
                    منها
                  </li>
                </ol>
                <div className="alert alert-info" style={{ lineHeight: "1.8" }}>
                  <strong>مثال عملي:</strong>
                  <br />
                  • بعت بضاعة بـ10,000  + 1,500  ضريبة ={" "}
                  <strong>11,500 </strong>
                  <br />
                  • اشتريت بضاعة بـ7,000  + 1,050  ضريبة ={" "}
                  <strong>8,050 </strong>
                  <br/>                  <strong>الحساب:</strong>
                  <br />
                  ضريبة المبيعات: 1,500
                  <br />
                  ضريبة المشتريات: 1,050
                  <br />
                  <strong>
                    المبلغ المستحق للحكومة: 1,500 - 1,050 = 450
                  </strong>
                </div>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>متى تحصل على استرداد؟</strong>
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  إذا كانت ضريبة مشترياتك <strong>أكبر من</strong> ضريبة مبيعاتك،
                  تسترد الفرق من الحكومة.
                </p>
                <div className="alert alert-success" style={{ lineHeight: "1.8" }}>
                  <strong>مثال:</strong>
                  <br />
                  • ضريبة المبيعات: 800
                  <br />
                  • ضريبة المشتريات: 1,200
                  <br />
                  <strong>الاسترداد: 1,200 - 800 = 400 </strong> تستردها من
                  الهيئة
                </div>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>شروط الاسترداد:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>✓ أن تكون مسجلاً في ضريبة القيمة المضافة</li>
                  <li>✓ وجود فاتورة ضريبية صحيحة</li>
                  <li>✓ المشتريات متعلقة بنشاطك التجاري</li>
                  <li>✓ تقديم الإقرار الضريبي في الموعد</li>
                  <li>✓ الاحتفاظ بالسجلات والفواتير لمدة 6 سنوات</li>
                </ul>
                <div
                  className="alert alert-warning mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>⚠️ ملاحظة:</strong> لا يمكن استرداد الضريبة على
                  المشتريات الشخصية أو غير المتعلقة بالنشاط التجاري.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماذا يحدث إذا لم ألتزم بضريبة القيمة المضافة؟
                </h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  عدم الالتزام بنظام <strong>ضريبة القيمة المضافة</strong> يعرضك
                  لـ<strong>غرامات وعقوبات مالية</strong> صارمة:
                </p>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>أنواع المخالفات والغرامات:</strong>
                </h4>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <h5 style={{ fontSize: "15px" }}>
                    <strong>1. عدم التسجيل في الموعد المحدد:</strong>
                  </h5>
                  <p>غرامة: <strong>10,000 </strong></p>
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <h5 style={{ fontSize: "15px" }}>
                    <strong>2. تأخير تقديم الإقرار الضريبي:</strong>
                  </h5>
                  <ul>
                    <li>
                      غرامة لا تقل عن <strong>5% ولا تزيد عن 25%</strong> من قيمة
                      الضريبة المستحقة
                    </li>
                    <li>
                      حد أدنى: <strong>1,000 </strong> إذا لم تكن هناك ضريبة
                      مستحقة
                    </li>
                  </ul>
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <h5 style={{ fontSize: "15px" }}>
                    <strong>3. تأخير سداد الضريبة المستحقة:</strong>
                  </h5>
                  <p>
                    غرامة: <strong>5%</strong> من قيمة الضريبة غير المسددة عن كل
                    شهر أو جزء منه
                  </p>
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <h5 style={{ fontSize: "15px" }}>
                    <strong>4. عدم إصدار فاتورة ضريبية:</strong>
                  </h5>
                  <p>
                    غرامة: <strong>50,000 </strong> أو أكثر حسب التكرار
                  </p>
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <h5 style={{ fontSize: "15px" }}>
                    <strong>5. إصدار فاتورة ضريبية من غير مسجل:</strong>
                  </h5>
                  <p>
                    غرامة: <strong>100,000 </strong>
                  </p>
                </div>
                <div
                  className="alert alert-danger"
                  style={{ lineHeight: "1.8", backgroundColor: "#f8d7da" }}
                >
                  <h5 style={{ fontSize: "15px" }}>
                    <strong>6. التهرب الضريبي المتعمد:</strong>
                  </h5>
                  <ul>
                    <li>
                      غرامة: قيمة الضريبة المستحقة أو <strong>ثلاثة أضعافها</strong>
                    </li>
                    <li>قد تصل العقوبة للسجن في الحالات الخطيرة</li>
                  </ul>
                </div>
                <h4 style={{ fontSize: "16px", marginTop: "15px" }}>
                  <strong>عقوبات إضافية:</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>إيقاف الخدمات الحكومية</li>
                  <li>عدم القدرة على تجديد التراخيص</li>
                  <li>منع السفر في حالات التهرب الكبيرة</li>
                  <li>نشر اسمك في قائمة المخالفين</li>
                  <li>الحجز على الحسابات البنكية</li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ نصيحة مهمة:</strong> الالتزام بالنظام يوفر عليك هذه
                  الغرامات الباهظة. استخدم <strong>حاسبة الضريبة</strong> للتأكد من
                  دقة حساباتك، وقدم إقراراتك في موعدها!
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default VATCalculator;